
export default {
  props: ['avantageCampusTexteGros2','avantageCampusTextePetit2','avantageCampusLogo2','texteCampusAvantage2']
}
